// When the tracker is shown inside an <iframe> (e.g. on the WordPress site),
// mark the page so CSS can hide our own scrollbar. The content still scrolls
// (wheel / trackpad / touch) — only the visible second scrollbar goes away.

export const isEmbedded = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true; // cross-origin access to window.top throws → we are framed
  }
};

export const markIfEmbedded = () => {
  if (isEmbedded()) document.documentElement.classList.add("embedded");
};
